import { useEffect, useState } from "react";
import { setHostedService } from "./hosted";
import { rpc } from "./rpc";

/**
 * Whether this deployment bills, read live from the account. The shell's bootstrap can be a saved
 * copy from an earlier visit (or from before sign-in on a desktop), which would hide Billing and
 * Help until a reload, so the answer is refetched when the signed-in user changes. The saved value
 * stands in until the fresh one arrives, and wins if the request fails.
 */
export function useBillingEnabled(userId: string | undefined, saved: boolean | undefined): boolean {
  const [fresh, setFresh] = useState<{ userId: string; value: boolean } | null>(null);
  useEffect(() => {
    if (!userId) return;
    let live = true;
    rpc
      .me()
      .then((me) => {
        setHostedService(me.hosted);
        if (live) setFresh({ userId, value: me.billingEnabled === true });
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [userId]);
  return fresh && fresh.userId === userId ? fresh.value : saved === true;
}
